import React, { useRef, useState } from "react";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import styles from "./styles.module.scss";
import { toast } from "react-toastify";
import ImageUploadIcon from "../../../../../assets/images/gallery.png";
import DeleteIcon from "../../../../../assets/images/trash.svg";
import FormInput from "../../global/FormInput/FormInput";
import FormSelect from "../../global/FormSelect/FormSelect";
const AddRewardItemModal = ({
  openModal,
  toggle,
  rewardItems,
  setRewardItems,
}) => {
  const inputRef = useRef();
  const [rewardName, setRewardName] = useState("");
  const [rewardDescription, setRewardDescription] = useState("");
  const [rewardImage, setRewardImage] = useState(null); // Changed to hold a single file
  const [rewardLink, setRewardLink] = useState("");
  const [rewardPoint, setRewardPoint] = useState("");
  const [rewardType, setRewardType] = useState("");

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    const validFiles = droppedFiles.filter((file) =>
      file.type.match("image/png|image/jpg|image/jpeg")
    );

    if (validFiles.length === 0) {
      toast.warning("Only PNG or JPG files are allowed.");
      return;
    }

    if (validFiles.length > 1) {
      toast.warning("Only one image can be uploaded.");
      return;
    }

    setRewardImage(validFiles[0]); // Store only the first valid file
  };

  const handleSave = () => {
    if (!rewardImage) {
      toast.warning("Please upload an image.");
      return;
    }

    const newRewardItem = {
      itemName: rewardName,
      itemDescription: rewardDescription,
      file: rewardImage, // Changed to hold a single file
      itemType: rewardType,
      itemPointValue: rewardPoint,
      itemRedeemURL: rewardLink,
    };

    if (rewardItems[0]?.itemName === "") {
      setRewardItems([newRewardItem]);
    } else {
      setRewardItems([...rewardItems, newRewardItem]);
    }

    toggle();
    setRewardName("");
    setRewardDescription("");
    setRewardImage(null); // Reset to null
    setRewardLink("");
    setRewardPoint("");
    setRewardType("");
  };

  return (
    <>
      <Modal
        isOpen={openModal}
        toggle={() => {
          toggle();
        }}
        centered
        fullscreen="sm"
        contentClassName={styles["modal_content"]}
        className={styles["modal_product_container"]}
        wrapClassName={styles["modal_wrapper"]}
      >
        <ModalBody className={styles["modal_location_body"]}>
          <div className={styles["modal_add_reward_header"]}>
            <h2 className={styles["modal_add_reward_header_title"]}>
              Add Reward Item
            </h2>
            <p className={styles["modal_add_reward_header_description"]}>
              Provide the details of the reward you wish to add.
            </p>
          </div>

          <Row>
            <Col md={6}>
              <div style={{ marginTop: "12px" }}>
                {" "}
                <FormInput
                  label="Name"
                  value={rewardName}
                  onChange={(e) => setRewardName(e.target.value)}
                  placeholder="Reward Name"
                />
              </div>
              <div style={{ marginTop: "12px" }}>
                <FormSelect
                  label="Type"
                  value={rewardType}
                  onChange={(e) => setRewardType(e.target.value)}
                  options={[
                    { value: "General Reward", label: "General Reward" },
                  ]}
                />
              </div>
              <div style={{ marginTop: "12px" }}>
                <FormInput
                  label="Points"
                  value={rewardPoint}
                  onChange={(e) => setRewardPoint(e.target.value)}
                  placeholder="Points"
                />
              </div>
              <div style={{ marginTop: "12px" }}>
                <FormInput
                  label="Links"
                  value={rewardLink}
                  onChange={(e) => setRewardLink(e.target.value)}
                  placeholder="Links"
                />
              </div>

              {/* description */}
              <div className={styles["modal_add_reward_form_field"]}>
                <label
                  htmlFor="points"
                  className={styles["modal_add_reward_form_label"]}
                >
                  Description
                </label>
                <textarea
                  rows={3}
                  type="text"
                  id="description"
                  value={rewardDescription}
                  onChange={(e) => setRewardDescription(e.target.value)}
                  className={styles["modal_add_reward_form_input"]}
                  style={{
                    height: "100%",
                  }}
                  maxLength={100}
                />
              </div>
            </Col>
            <Col md={6}>
              <div className={styles["image_upload_wrapper"]}>
                <div
                  className={styles["file_upload_container"]}
                  onClick={() => {
                    inputRef?.current?.click();
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => {}}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <img src={ImageUploadIcon} alt="img" width={24} height={24} />
                  <div>
                    <p className={styles["upload_text"]}>
                      Image upload (Drag and drop)
                    </p>
                  </div>
                </div>
                <input
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  ref={inputRef}
                  style={{
                    display: "none",
                  }}
                  name="Images"
                  id="Images"
                  onChange={(event) => {
                    const file = event.target.files?.[0]; // Get only the first file
                    if (!file) return;

                    if (!file.type.match("image/png|image/jpg|image/jpeg")) {
                      toast.warning("Only PNG or JPG files are allowed.");
                      return;
                    }

                    setRewardImage(file); // Store the single file
                  }}
                />
                {rewardImage && (
                  <div className={styles["document_view"]}>
                    <div className={styles["image_name"]}>
                      {rewardImage.name}
                    </div>
                    <div
                      className={styles["delete_icon"]}
                      onClick={() => {
                        setRewardImage(null); // Clear the image
                      }}
                      role="button"
                      tabIndex={0}
                      onKeyDown={() => {}}
                    >
                      <img
                        src={DeleteIcon}
                        width={25}
                        height={25}
                        alt="delete"
                      />
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <div className={styles._button_wrapper}>
            <button className={styles._cancel_button} onClick={toggle}>
              Cancel
            </button>
            <button className={styles._save_button} onClick={handleSave}>
              Save
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AddRewardItemModal;
// import React, { useRef, useState } from "react";
// import { Col, Modal, ModalBody, Row } from "reactstrap";
// import styles from "./styles.module.scss";
// import { toast } from "react-toastify";
// import ImageUploadIcon from "../../../../../assets/images/gallery.png";
// import DeleteIcon from "../../../../../assets/images/trash.svg";
// import FormInput from "../../global/FormInput/FormInput";
// import FormSelect from "../../global/FormSelect/FormSelect";

// const AddRewardItemModal = ({
//   openModal,
//   toggle,
//   rewardItems,
//   setRewardItems,
// }) => {
//   const inputRef = useRef();
//   const [rewardName, setRewardName] = useState();
//   const [rewardDescription, setRewardDescription] = useState();
//   const [rewardImage, setRewardImage] = useState();
//   const [rewardLink, setRewardLink] = useState();
//   const [rewardPoint, setRewardPoint] = useState();
//   const [rewardType, setRewardType] = useState();

//   const handleDragOver = (event) => {
//     event.preventDefault();
//   };

//   const handleDrop = (event) => {
//     event.preventDefault();
//     const droppedFiles = Array.from(event.dataTransfer.files);
//     const validFiles = droppedFiles.filter((file) =>
//       file.type.match(
//         "image/png|image/jpg|image/jpeg|application/pdf|application/msword|application/vnd.openxmlformats-officedocument.wordprocessingml.document"
//       )
//     );
//     if (validFiles.length !== droppedFiles.length) {
//       toast.warning("Only PNG, JPG, PDF, DOC, or DOCX files are allowed.");
//     }
//     const updatedFiles = [...(rewardImage || []), ...validFiles];
//     if (updatedFiles.length > 4) {
//       toast.warning("Only 4 documents allowed.");
//       return;
//     }
//     setRewardImage(updatedFiles);
//   };

//   const handleSave = () => {
//     const newRewardItem = {
//       itemName: rewardName,
//       itemDescription: rewardDescription,
//       files: rewardImage,
//       itemType: rewardType,
//       itemPointValue: rewardPoint,
//       itemRedeemURL: rewardLink,
//     };

//     if (rewardItems[0]?.itemName === "") {
//       setRewardItems([newRewardItem]);
//     } else {
//       setRewardItems([...rewardItems, newRewardItem]);
//     }

//     toggle();
//     setRewardName("");
//     setRewardDescription("");
//     setRewardImage([]);
//     setRewardLink("");
//     setRewardPoint("");
//     setRewardType("");
//   };

//   return (
//     <>
//       <Modal
//         isOpen={openModal}
//         toggle={() => {
//           toggle();
//         }}
//         centered
//         fullscreen="sm"
//         contentClassName={styles["modal_content"]}
//         className={styles["modal_product_container"]}
//         wrapClassName={styles["modal_wrapper"]}
//       >
//         <ModalBody className={styles["modal_location_body"]}>
//           <div className={styles["modal_add_reward_header"]}>
//             <h2 className={styles["modal_add_reward_header_title"]}>
//               Add Reward Item
//             </h2>
//             <p className={styles["modal_add_reward_header_description"]}>
//               Provide the details of the reward you wish to add.
//             </p>
//           </div>

//           <Row>
//             <Col md={6}>
//               <div style={{ marginTop: "12px" }}>
//                 {" "}
//                 <FormInput
//                   label="Name"
//                   value={rewardName}
//                   onChange={(e) => setRewardName(e.target.value)}
//                   placeholder="Reward Name"
//                 />
//               </div>
//               <div style={{ marginTop: "12px" }}>
//                 <FormSelect
//                   label="Type"
//                   value={rewardType}
//                   onChange={(e) => setRewardType(e.target.value)}
//                   options={[
//                     { value: "General Reward", label: "General Reward" },
//                   ]}
//                 />
//               </div>
//               <div style={{ marginTop: "12px" }}>
//                 <FormInput
//                   label="Points"
//                   value={rewardPoint}
//                   onChange={(e) => setRewardPoint(e.target.value)}
//                   placeholder="Points"
//                 />
//               </div>
//               <div style={{ marginTop: "12px" }}>
//                 <FormInput
//                   label="Links"
//                   value={rewardLink}
//                   onChange={(e) => setRewardLink(e.target.value)}
//                   placeholder="Links"
//                 />
//               </div>

//               {/* description */}
//               <div className={styles["modal_add_reward_form_field"]}>
//                 <label
//                   htmlFor="points"
//                   className={styles["modal_add_reward_form_label"]}
//                 >
//                   Description
//                 </label>
//                 <textarea
//                   rows={3}
//                   type="text"
//                   id="description"
//                   value={rewardDescription}
//                   onChange={(e) => setRewardDescription(e.target.value)}
//                   className={styles["modal_add_reward_form_input"]}
//                   style={{
//                     height: "100%",
//                   }}
//                   maxLength={100}
//                 />
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className={styles["image_upload_wrapper"]}>
//                 <div
//                   className={styles["file_upload_container"]}
//                   onClick={() => {
//                     inputRef?.current?.click();
//                   }}
//                   role="button"
//                   tabIndex={0}
//                   onKeyDown={() => {}}
//                   onDragOver={handleDragOver}
//                   onDrop={handleDrop}
//                 >
//                   <img src={ImageUploadIcon} alt="img" width={24} height={24} />
//                   <div>
//                     <p className={styles["upload_text"]}>
//                       Documents upload (Drag and drop)
//                     </p>
//                   </div>
//                 </div>
//                 <input
//                   type="file"
//                   accept=".png, .jpg, .jpeg, .pdf, .doc, .docx"
//                   ref={inputRef}
//                   style={{
//                     display: "none",
//                   }}
//                   name="Images"
//                   id="Images"
//                   multiple
//                   onChange={(event) => {
//                     const filesArray = Array.from(event.target.files || []);
//                     if (filesArray.length > 4) {
//                       toast.warning("Only 4 documents allowed.");
//                       return;
//                     }
//                     const updatedFiles = [
//                       ...(rewardImage || []),
//                       ...filesArray,
//                     ];
//                     setRewardImage(updatedFiles);
//                   }}
//                 />
//                 <div className={styles["documents_view_container"]}>
//                   {(rewardImage || []).map((file, index) => (
//                     <div className={styles["document_view"]} key={index}>
//                       <div className={styles["image_name"]}>{file.name}</div>
//                       <div
//                         className={styles["delete_icon"]}
//                         onClick={() => {
//                           const currentFiles = [...rewardImage];
//                           currentFiles.splice(index, 1);
//                           setRewardImage(currentFiles);
//                         }}
//                         role="button"
//                         tabIndex={0}
//                         onKeyDown={() => {}}
//                       >
//                         <img
//                           src={DeleteIcon}
//                           width={25}
//                           height={25}
//                           alt="delete"
//                         />
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </Col>
//           </Row>

//           <div className={styles._button_wrapper}>
//             <button className={styles._cancel_button} onClick={toggle}>
//               Cancel
//             </button>
//             <button className={styles._save_button} onClick={handleSave}>
//               Save
//             </button>
//           </div>
//         </ModalBody>
//       </Modal>
//     </>
//   );
// };

// export default AddRewardItemModal;
